import { render, staticRenderFns } from "./infoCard.vue?vue&type=template&id=f6491340&scoped=true&"
import script from "./infoCard.vue?vue&type=script&lang=js&"
export * from "./infoCard.vue?vue&type=script&lang=js&"
import style0 from "./infoCard.vue?vue&type=style&index=0&id=f6491340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6491340",
  null
  
)

export default component.exports